//messages.js
export default {
    parent_id: "Parent Id",
    stripe_id: "Stripe Id",
    zoho_customer_id: "Zoho Customer Id",
    organisation_type_id: "Organisation Type Id",
    company: "Company",
    company_short: "Company Short",
    website: "Website",
    correspondence_method: "Correspondence Method",
    currency_code: "Currency Code",
    turn_around_days: "Turn Around Days",
    has_nda: "Has Nda",
    has_contract: "Has Contract",
    ship_label_type: "Ship Label Type",
    logo_id: "Logo Id",
    packing_list_fields: "Packing List Fields",
    logo: "Logo",
    status: "Status",
    edit_vendor: "Edit Vendor",
    add_vendor: "Add Vendor",
    delete_vendor: "Delete Vendor",
    vendors: "Vendors",
    delete_vendor_confirm: "This action is not reversible!",
};
